import _Object$keys from 'babel-runtime/core-js/object/keys';
import _extends from 'babel-runtime/helpers/extends';
import _Object$values from 'babel-runtime/core-js/object/values';
import data from './emoji-data.js';
var emojiData = {};
_Object$values(data).forEach(function (item) {
  emojiData = _extends({}, emojiData, item);
});

/**
 *
 *
 * @export
 * @param {string} value
 * @returns {string}
 */

export function emoji(value) {
  if (!value) return;
  _Object$keys(emojiData).forEach(function (item) {
    value = value.replace(new RegExp(item, 'g'), createIcon(item));
  });
  return value;
}

function createIcon(item) {
  var value = emojiData[item];
  var path = process.env.NODE_ENV == 'development' ? '../../static/img/emoji/' : './static/img/emoji/';
  return '<img src=' + path + value + ' width="16px" height="16px">';
}